import React from "react";
import { Switch } from "@headlessui/react";

const EmeraldSwitch = ({ checked, onChange, disabled }) => (
  <Switch
    checked={!!checked}
    onChange={onChange}       // <- verwacht boolean
    disabled={disabled}
    className={`${
      checked ? "bg-emerald-600" : "bg-gray-300 dark:bg-gray-600"
    } relative inline-flex h-6 w-11 items-center rounded-full transition
       focus:outline-none focus:ring-2 focus:ring-emerald-400/70
       disabled:opacity-60`}
  >
    <span
      className={`${
        checked ? "translate-x-6" : "translate-x-1"
      } inline-block h-4 w-4 transform rounded-full bg-white transition`}
    />
  </Switch>
);

export default EmeraldSwitch;